import { render, staticRenderFns } from "./unready.vue?vue&type=template&id=3cde9fef&scoped=true&"
import script from "./unready.vue?vue&type=script&lang=js&"
export * from "./unready.vue?vue&type=script&lang=js&"
import style0 from "./unready.vue?vue&type=style&index=0&id=3cde9fef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cde9fef",
  null
  
)

export default component.exports